import { useState, useEffect, useRef } from "react";

// ─── CSS de animaciones ───
const LANDING_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800;900&family=DM+Sans:wght@400;500;600&family=Baloo+2:wght@700;800&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .lp-root {
    background: #060B14;
    color: #E2E8F0;
    font-family: 'DM Sans', sans-serif;
    overflow-x: hidden;
    min-height: 100vh;
  }

  /* ── Fade-in utility ── */
  .reveal {
    opacity: 0;
    transform: translateY(32px);
    transition: opacity .7s ease, transform .7s ease;
  }
  .reveal.visible {
    opacity: 1;
    transform: none;
  }

  /* ── Nav ── */
  .lp-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 18px 48px;
    background: rgba(6,11,20,.85);
    backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(255,255,255,.06);
    transition: all .3s;
  }
  .lp-nav-logo {
    font-family: 'Baloo 2', cursive;
    font-weight: 800; font-size: 22px;
    background: linear-gradient(135deg, #FB923C, #F97316);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  }
  .lp-nav-link {
    font-size: 14px; font-weight: 600; color: #94A3B8;
    cursor: pointer; border: none; background: none;
    transition: color .2s; text-decoration: none;
  }
  .lp-nav-link:hover { color: #FB923C; }
  .lp-nav-cta {
    background: linear-gradient(135deg, #FB923C, #F97316);
    color: white; border: none; border-radius: 12px;
    padding: 10px 22px; font-size: 14px; font-weight: 700;
    cursor: pointer; transition: transform .15s, box-shadow .15s;
    font-family: 'DM Sans', sans-serif;
    text-decoration: none; display: inline-block;
  }
  .lp-nav-cta:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(251,146,60,.35);
  }

  /* ── Hero ── */
  .lp-hero {
    min-height: 100vh;
    display: flex; align-items: center; justify-content: center;
    text-align: center;
    padding: 120px 24px 80px;
    position: relative;
    overflow: hidden;
  }
  .lp-hero-bg {
    position: absolute; inset: 0; z-index: 0;
    background:
      radial-gradient(ellipse 80% 60% at 50% -10%, rgba(251,146,60,.18) 0%, transparent 70%),
      radial-gradient(ellipse 40% 40% at 80% 80%, rgba(139,92,246,.1) 0%, transparent 60%);
  }
  .lp-hero-grid {
    position: absolute; inset: 0; z-index: 0;
    background-image:
      linear-gradient(rgba(255,255,255,.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,.03) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
  }
  .lp-hero-content { position: relative; z-index: 1; max-width: 800px; }
  .lp-hero-badge {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(251,146,60,.12); border: 1px solid rgba(251,146,60,.3);
    border-radius: 999px; padding: 6px 18px;
    font-size: 13px; font-weight: 600; color: #FB923C;
    margin-bottom: 28px;
    animation: badgePop .6s ease-out both;
  }
  @keyframes badgePop {
    from { opacity: 0; transform: scale(.9); }
    to   { opacity: 1; transform: scale(1); }
  }
  .lp-hero-title {
    font-family: 'Syne', sans-serif;
    font-size: clamp(44px, 7vw, 88px);
    font-weight: 900;
    line-height: 1.0;
    color: white;
    margin-bottom: 24px;
    animation: heroSlide .8s ease-out .1s both;
  }
  .lp-hero-title span {
    background: linear-gradient(135deg, #FB923C, #F97316, #EA580C);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  }
  @keyframes heroSlide {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: none; }
  }
  .lp-hero-sub {
    font-size: clamp(17px, 2.5vw, 21px);
    color: #94A3B8; line-height: 1.65;
    max-width: 600px; margin: 0 auto 40px;
    animation: heroSlide .8s ease-out .25s both;
  }
  .lp-hero-actions {
    display: flex; gap: 14px; justify-content: center; flex-wrap: wrap;
    animation: heroSlide .8s ease-out .4s both;
  }
  .lp-btn-primary {
    background: linear-gradient(135deg, #FB923C, #F97316);
    color: white; border: none; border-radius: 16px;
    padding: 16px 32px; font-size: 17px; font-weight: 700;
    cursor: pointer; transition: transform .15s, box-shadow .15s;
    font-family: 'DM Sans', sans-serif; text-decoration: none;
    display: inline-flex; align-items: center; gap: 8px;
  }
  .lp-btn-primary:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(251,146,60,.4);
  }
  .lp-btn-secondary {
    background: rgba(255,255,255,.06); color: #E2E8F0;
    border: 1px solid rgba(255,255,255,.12); border-radius: 16px;
    padding: 16px 32px; font-size: 17px; font-weight: 600;
    cursor: pointer; transition: all .15s;
    font-family: 'DM Sans', sans-serif; text-decoration: none;
    display: inline-flex; align-items: center; gap: 8px;
  }
  .lp-btn-secondary:hover {
    background: rgba(255,255,255,.1);
    border-color: rgba(255,255,255,.25);
  }
  .lp-hero-scroll {
    position: absolute; bottom: 36px; left: 50%; transform: translateX(-50%);
    display: flex; flex-direction: column; align-items: center; gap: 6px;
    color: #475569; font-size: 12px; font-weight: 600; letter-spacing: 2px;
    text-transform: uppercase; animation: bounce 2s ease-in-out infinite;
  }
  @keyframes bounce {
    0%, 100% { transform: translateX(-50%) translateY(0); }
    50%       { transform: translateX(-50%) translateY(8px); }
  }

  /* ── Stats row ── */
  .lp-stats {
    display: flex; justify-content: center; flex-wrap: wrap; gap: 0;
    border-top: 1px solid rgba(255,255,255,.06);
    border-bottom: 1px solid rgba(255,255,255,.06);
  }
  .lp-stat {
    flex: 1; min-width: 160px; max-width: 240px;
    padding: 36px 24px; text-align: center;
    border-right: 1px solid rgba(255,255,255,.06);
  }
  .lp-stat:last-child { border-right: none; }
  .lp-stat-num {
    font-family: 'Syne', sans-serif;
    font-size: 40px; font-weight: 900; color: #FB923C;
    line-height: 1; margin-bottom: 6px;
  }
  .lp-stat-label { font-size: 13px; color: #64748B; font-weight: 600; }

  /* ── Section common ── */
  .lp-section { padding: 100px 24px; max-width: 1100px; margin: 0 auto; }
  .lp-section-label {
    font-size: 12px; font-weight: 700; letter-spacing: 3px;
    text-transform: uppercase; color: #FB923C; margin-bottom: 16px;
  }
  .lp-section-title {
    font-family: 'Syne', sans-serif;
    font-size: clamp(32px, 5vw, 52px);
    font-weight: 800; color: white; line-height: 1.1; margin-bottom: 16px;
  }
  .lp-section-sub {
    font-size: 18px; color: #64748B; line-height: 1.65; max-width: 560px;
  }

  /* ── Features grid ── */
  .lp-features {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px; margin-top: 56px;
  }
  .lp-feature-card {
    background: #0D1520;
    border: 1px solid rgba(255,255,255,.07);
    border-radius: 24px; padding: 32px;
    transition: border-color .2s, transform .2s;
  }
  .lp-feature-card:hover {
    border-color: rgba(251,146,60,.3);
    transform: translateY(-4px);
  }
  .lp-feature-icon {
    width: 52px; height: 52px; border-radius: 16px;
    background: rgba(251,146,60,.1); border: 1px solid rgba(251,146,60,.2);
    display: flex; align-items: center; justify-content: center;
    font-size: 26px; margin-bottom: 20px;
  }
  .lp-feature-title {
    font-family: 'Syne', sans-serif;
    font-size: 19px; font-weight: 800; color: white; margin-bottom: 10px;
  }
  .lp-feature-desc { font-size: 15px; color: #64748B; line-height: 1.6; }

  /* ── Portals section ── */
  .lp-portals {
    display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px;
    margin-top: 56px;
  }
  @media (max-width: 640px) { .lp-portals { grid-template-columns: 1fr; } }
  .lp-portal-card {
    border-radius: 20px; padding: 28px 32px;
    position: relative; overflow: hidden;
  }
  .lp-portal-badge {
    display: inline-block; font-size: 11px; font-weight: 700;
    letter-spacing: 1px; text-transform: uppercase;
    padding: 4px 12px; border-radius: 999px; margin-bottom: 16px;
  }
  .lp-portal-name {
    font-family: 'Syne', sans-serif;
    font-size: 24px; font-weight: 800; color: white; margin-bottom: 10px;
  }
  .lp-portal-desc { font-size: 14px; line-height: 1.6; }
  .lp-portal-emoji {
    position: absolute; right: 24px; bottom: 24px;
    font-size: 56px; opacity: .15;
  }

  /* ── Pricing ── */
  .lp-pricing {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px; margin-top: 56px; align-items: start;
  }
  .lp-plan {
    background: #0D1520;
    border: 1px solid rgba(255,255,255,.07);
    border-radius: 28px; padding: 36px 32px;
    position: relative;
    transition: transform .2s;
  }
  .lp-plan:hover { transform: translateY(-4px); }
  .lp-plan.featured {
    border-color: #FB923C;
    background: linear-gradient(160deg, #0D1520, #1A1005);
    box-shadow: 0 0 60px rgba(251,146,60,.12);
  }
  .lp-plan-badge {
    position: absolute; top: -14px; left: 50%; transform: translateX(-50%);
    background: linear-gradient(135deg, #FB923C, #F97316);
    color: white; font-size: 12px; font-weight: 700; letter-spacing: 1px;
    text-transform: uppercase; padding: 5px 18px; border-radius: 999px;
    white-space: nowrap;
  }
  .lp-plan-name {
    font-family: 'Syne', sans-serif;
    font-size: 22px; font-weight: 800; color: white; margin-bottom: 8px;
  }
  .lp-plan-desc { font-size: 14px; color: #64748B; margin-bottom: 28px; line-height: 1.5; }
  .lp-plan-price {
    display: flex; align-items: baseline; gap: 6px; margin-bottom: 8px;
  }
  .lp-plan-amount {
    font-family: 'Syne', sans-serif;
    font-size: 44px; font-weight: 900; color: white;
  }
  .lp-plan-period { font-size: 15px; color: #64748B; }
  .lp-plan-limit { font-size: 13px; color: #475569; margin-bottom: 28px; }
  .lp-plan-divider {
    height: 1px; background: rgba(255,255,255,.06); margin-bottom: 24px;
  }
  .lp-plan-feature {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 14px; color: #94A3B8; margin-bottom: 12px; line-height: 1.4;
  }
  .lp-plan-feature-check { color: #4ADE80; font-size: 15px; flex-shrink: 0; margin-top: 1px; }
  .lp-plan-feature-x { color: #334155; font-size: 15px; flex-shrink: 0; margin-top: 1px; }
  .lp-plan-cta {
    width: 100%; padding: 14px; border-radius: 14px;
    font-size: 15px; font-weight: 700; cursor: pointer;
    font-family: 'DM Sans', sans-serif; margin-top: 28px;
    transition: all .15s;
  }
  .lp-plan-cta.orange {
    background: linear-gradient(135deg, #FB923C, #F97316);
    color: white; border: none;
  }
  .lp-plan-cta.orange:hover { box-shadow: 0 8px 24px rgba(251,146,60,.35); }
  .lp-plan-cta.outline {
    background: transparent; color: #94A3B8;
    border: 1px solid rgba(255,255,255,.12);
  }
  .lp-plan-cta.outline:hover { border-color: rgba(255,255,255,.25); color: white; }

  /* ── How it works ── */
  .lp-steps {
    display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0; margin-top: 56px; position: relative;
  }
  .lp-step {
    padding: 36px 32px; text-align: center;
    border-right: 1px solid rgba(255,255,255,.06);
    position: relative;
  }
  .lp-step:last-child { border-right: none; }
  .lp-step-num {
    font-family: 'Syne', sans-serif;
    font-size: 64px; font-weight: 900;
    color: rgba(251,146,60,.15); line-height: 1; margin-bottom: 12px;
  }
  .lp-step-title {
    font-family: 'Syne', sans-serif;
    font-size: 18px; font-weight: 800; color: white; margin-bottom: 10px;
  }
  .lp-step-desc { font-size: 14px; color: #64748B; line-height: 1.6; }

  /* ── FAQ ── */
  .lp-faq { display: flex; flex-direction: column; gap: 12px; margin-top: 48px; }
  .lp-faq-item {
    background: #0D1520;
    border: 1px solid rgba(255,255,255,.07);
    border-radius: 16px; overflow: hidden;
    transition: border-color .2s;
  }
  .lp-faq-item.open { border-color: rgba(251,146,60,.25); }
  .lp-faq-q {
    width: 100%; padding: 20px 24px;
    display: flex; justify-content: space-between; align-items: center; gap: 16px;
    background: none; border: none; cursor: pointer; text-align: left;
  }
  .lp-faq-q-text { font-size: 16px; font-weight: 600; color: white; }
  .lp-faq-arrow { font-size: 18px; color: #FB923C; transition: transform .25s; flex-shrink: 0; }
  .lp-faq-item.open .lp-faq-arrow { transform: rotate(180deg); }
  .lp-faq-a {
    padding: 0 24px; max-height: 0; overflow: hidden;
    font-size: 15px; color: #64748B; line-height: 1.7;
    transition: max-height .3s ease, padding .3s ease;
  }
  .lp-faq-item.open .lp-faq-a { max-height: 300px; padding: 0 24px 20px; }

  /* ── CTA Final ── */
  .lp-cta-section {
    padding: 120px 24px;
    text-align: center;
    background: linear-gradient(160deg, rgba(251,146,60,.06) 0%, transparent 60%);
    border-top: 1px solid rgba(255,255,255,.06);
  }
  .lp-cta-title {
    font-family: 'Syne', sans-serif;
    font-size: clamp(36px, 5vw, 60px);
    font-weight: 900; color: white; margin-bottom: 20px; line-height: 1.1;
  }
  .lp-cta-sub { font-size: 18px; color: #64748B; margin-bottom: 40px; }
  .lp-wa-btn {
    display: inline-flex; align-items: center; gap: 10px;
    background: #25D366; color: white; border: none; border-radius: 16px;
    padding: 16px 32px; font-size: 17px; font-weight: 700;
    cursor: pointer; transition: transform .15s, box-shadow .15s;
    font-family: 'DM Sans', sans-serif; text-decoration: none;
  }
  .lp-wa-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(37,211,102,.35);
  }

  /* ── Footer ── */
  .lp-footer {
    padding: 40px 48px;
    border-top: 1px solid rgba(255,255,255,.06);
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 16px;
  }
  .lp-footer-logo {
    font-family: 'Baloo 2', cursive;
    font-weight: 800; font-size: 18px; color: #475569;
  }
  .lp-footer-copy { font-size: 13px; color: #334155; }

  /* ── Responsive ── */
  @media (max-width: 768px) {
    .lp-nav { padding: 14px 20px; }
    .lp-section { padding: 72px 20px; }
    .lp-footer { padding: 28px 20px; }
    .lp-stat { padding: 24px 16px; }
    .lp-steps { grid-template-columns: 1fr; }
    .lp-step { border-right: none; border-bottom: 1px solid rgba(255,255,255,.06); }
    .lp-step:last-child { border-bottom: none; }
    .lp-nav-links { display: none; }
  }
`;

// ─── Reveal hook ───
function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add("visible"); obs.disconnect(); }
    }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

// ─── Section components ───
function Reveal({ children, style }) {
  const ref = useReveal();
  return <div ref={ref} className="reveal" style={style}>{children}</div>;
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div className="lp-feature-card">
      <div className="lp-feature-icon">{icon}</div>
      <div className="lp-feature-title">{title}</div>
      <div className="lp-feature-desc">{desc}</div>
    </div>
  );
}

function PortalCard({ emoji, badge, badgeColor, name, desc, bg, border }) {
  return (
    <div className="lp-portal-card" style={{ background: bg, border }}>
      <div className="lp-portal-badge" style={{ background: badgeColor + "22", color: badgeColor }}>{badge}</div>
      <div className="lp-portal-name">{name}</div>
      <div className="lp-portal-desc" style={{ color: "#94A3B8" }}>{desc}</div>
      <div className="lp-portal-emoji">{emoji}</div>
    </div>
  );
}

function PlanCard({ name, desc, price, period, limit, features, cta, ctaStyle, featured, badge, onCta }) {
  return (
    <div className={`lp-plan${featured ? " featured" : ""}`}>
      {badge && <div className="lp-plan-badge">{badge}</div>}
      <div className="lp-plan-name">{name}</div>
      <div className="lp-plan-desc">{desc}</div>
      <div className="lp-plan-price">
        <div className="lp-plan-amount">{price}</div>
        {period && <div className="lp-plan-period">{period}</div>}
      </div>
      <div className="lp-plan-limit">{limit}</div>
      <div className="lp-plan-divider" />
      {features.map((f, i) => (
        <div key={i} className="lp-plan-feature">
          <span className={f.ok ? "lp-plan-feature-check" : "lp-plan-feature-x"}>{f.ok ? "✓" : "✕"}</span>
          <span style={{ color: f.ok ? "#CBD5E1" : "#475569" }}>{f.label}</span>
        </div>
      ))}
      <button className={`lp-plan-cta ${ctaStyle}`} onClick={onCta}>{cta}</button>
    </div>
  );
}

const FAQS = [
  { q: "¿Necesito instalar algo?", a: "No. La Tiendita CR es 100% web. Funciona en cualquier celular, tablet o computadora con navegador. No hay apps que descargar ni programas que instalar." },
  { q: "¿Qué pasa si no tengo internet en la soda?", a: "El sistema requiere conexión a internet para recibir pedidos y procesar pagos. Recomendamos tener WiFi o datos móviles disponibles en el área de la soda. En caso de fallo de conexión, el vendedor puede seguir atendiendo en el POS cuando la conexión se restaure." },
  { q: "¿Puedo cambiar de plan en cualquier momento?", a: "Sí. Podés subir o bajar de plan cuando quieras. El cambio aplica al siguiente período de facturación. Si subís de plan a mitad de mes, te cobramos el proporcional." },
  { q: "¿Mis datos están seguros?", a: "Sí. El sistema corre sobre Firebase de Google, con encriptación en tránsito y en reposo. Cada escuela tiene sus datos completamente aislados — ninguna institución puede ver los datos de otra. Cumplimos con las mejores prácticas de seguridad para datos de menores." },
  { q: "¿Cómo se registran los padres?", a: "Los padres entran a tienditacr.app/school/[nombre-escuela]/padres y crean su cuenta con correo y contraseña. El admin de la soda les puede enviar el link directo. No necesitan ningún código de invitación." },
  { q: "¿Qué métodos de pago aceptan los padres?", a: "Los padres pueden pagar por SINPE Móvil, transferencia bancaria o en efectivo. Suben el comprobante desde el portal y el admin lo aprueba. También se puede registrar un pago vía WhatsApp sin comprobante." },
  { q: "¿Funciona para escuelas con varias sodas?", a: "Sí. El plan Premium soporta localidades ilimitadas. Cada localidad puede tener su propio punto de venta (POS) con un vendedor asignado, todo bajo la misma escuela." },
  { q: "¿Qué pasa con mis datos si cancelo?", a: "Tus datos se conservan durante 30 días después de cancelar, durante los cuales podés solicitar una exportación completa en PDF. Después de ese período, se eliminan permanentemente." },
];

function FaqSection() {
  const [open, setOpen] = useState(null);
  return (
    <div className="lp-faq">
      {FAQS.map((f, i) => (
        <div key={i} className={`lp-faq-item${open === i ? " open" : ""}`}>
          <button className="lp-faq-q" onClick={() => setOpen(open === i ? null : i)}>
            <span className="lp-faq-q-text">{f.q}</span>
            <span className="lp-faq-arrow">▾</span>
          </button>
          <div className="lp-faq-a">{f.a}</div>
        </div>
      ))}
    </div>
  );
}

// ─── Main landing ───
export default function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const openWhatsApp = () => {
    const msg = "Hola, me interesa conocer más sobre La Tiendita CR para mi institución. ¿Podrían darme más información?";
    window.open(`https://wa.me/50688872962?text=${encodeURIComponent(msg)}`, "_blank");
  };

  // Slug de la escuela demo — cambiá "sanfra" por el slug real de tu escuela demo
  const DEMO_SLUG = "escuelademo";
  const goToDemo = () => { window.location.href = `/school/${DEMO_SLUG}/estudiante`; };

  return (
    <div className="lp-root">
      <style>{LANDING_CSS}</style>

      {/* ── NAV ── */}
      <nav className="lp-nav">
        <div className="lp-nav-logo"><img src="/logo.png" alt="La Tiendita CR" style={{ height: 38, width: "auto", objectFit: "contain" }} /></div>
        <div className="lp-nav-links" style={{ display: "flex", gap: 32, alignItems: "center" }}>
          <button className="lp-nav-link" onClick={() => scrollTo("features")}>Funciones</button>
          <button className="lp-nav-link" onClick={() => scrollTo("portals")}>Portales</button>
          <button className="lp-nav-link" onClick={() => scrollTo("pricing")}>Precios</button>
          <button className="lp-nav-link" onClick={() => scrollTo("contact")}>Contacto</button>
        </div>
        <button className="lp-nav-cta" onClick={openWhatsApp}>Solicitar Demo</button>
      </nav>

      {/* ── HERO ── */}
      <section className="lp-hero">
        <div className="lp-hero-bg" />
        <div className="lp-hero-grid" />
        <div className="lp-hero-content">
          <div className="lp-hero-badge">
            <span>🇨🇷</span> Hecho para sodas escolares en Costa Rica
          </div>
          <h1 className="lp-hero-title">
            La soda de tu escuela,<br />
            <span>sin el caos</span>
          </h1>
          <p className="lp-hero-sub">
            Sistema digital completo para administrar pedidos, pagos y menús escolares. Los padres pagan con SINPE, los estudiantes piden desde su código, los vendedores despachan sin errores.
          </p>
          <div className="lp-hero-actions">
            <button className="lp-btn-primary" onClick={openWhatsApp}>
              💬 Solicitar Demo Gratis
            </button>
            <button className="lp-btn-secondary" onClick={goToDemo}>
              🏪 Ver demo en vivo
            </button>
          </div>
          <p style={{ marginTop: 16, fontSize: 12, color: "#334155", animation: "heroSlide .8s ease-out .5s both" }}>
            La demo es una escuela de prueba con datos reales — sin registrarte
          </p>
        </div>
        <div className="lp-hero-scroll">
          <span>scroll</span>
          <span style={{ fontSize: 18 }}>↓</span>
        </div>
      </section>

      {/* ── STATS ── */}
      <Reveal>
        <div className="lp-stats">
          {[
            { num: "0", label: "Planillas de Excel" },
            { num: "4", label: "Portales integrados" },
            { num: "100%", label: "Web, sin instalar nada" },
            { num: "24/7", label: "Disponible siempre" },
          ].map(s => (
            <div key={s.label} className="lp-stat">
              <div className="lp-stat-num">{s.num}</div>
              <div className="lp-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>

      {/* ── FEATURES ── */}
      <section id="features">
        <div className="lp-section">
          <Reveal>
            <div className="lp-section-label">Funcionalidades</div>
            <h2 className="lp-section-title">Todo lo que necesitás,<br />nada de lo que no</h2>
            <p className="lp-section-sub">
              Diseñado específicamente para el flujo de una soda escolar en Costa Rica. No es un sistema genérico adaptado — fue construido para esto.
            </p>
          </Reveal>
          <Reveal style={{ transitionDelay: ".1s" }}>
            <div className="lp-features">
              {[
                { icon: "📋", title: "Cola de pedidos en vivo", desc: "Los vendedores ven los pedidos en tiempo real. El primer pedido de la cola tiene un indicador visual. Sin papelitos, sin confusión." },
                { icon: "💳", title: "Pagos por SINPE y transferencia", desc: "Los padres suben el comprobante desde su teléfono. El admin lo aprueba en un click. También se puede registrar pago vía WhatsApp sin comprobante." },
                { icon: "📅", title: "Menú semanal interactivo", desc: "Armá el menú de cada día arrastrando productos a las columnas. El viernes se limpia automáticamente para la siguiente semana." },
                { icon: "🧾", title: "Facturación semanal automática", desc: "El sistema agrupa todos los pedidos de crédito por padre y genera las facturas. Se envían por correo con un solo click." },
                { icon: "📊", title: "Reportes de ventas en PDF", desc: "Reporte diario, semanal y mensual con totales por método de pago, productos más vendidos y gráficos de actividad." },
                { icon: "🔒", title: "Multi-escuela seguro", desc: "Cada escuela tiene sus datos completamente aislados. Un solo sistema, múltiples instituciones, sin que una vea los datos de otra." },
                { icon: "🎒", title: "Estudiantes autónomos", desc: "Para colegios y niveles superiores: estudiantes que manejan su propio dinero. Saldo prepagado, pago en efectivo o SINPE. Sin necesidad de cuenta de padre." },
                { icon: "🤖", title: "Asistente virtual con IA", desc: "Chatbot integrado en todos los portales. Los padres y estudiantes preguntan en lenguaje natural y reciben respuestas instantáneas. El panel del vendedor tiene su propio asistente técnico." },
              ].map(f => <FeatureCard key={f.title} {...f} />)}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── PORTALS ── */}
      <section id="portals" style={{ background: "rgba(255,255,255,.015)", borderTop: "1px solid rgba(255,255,255,.06)", borderBottom: "1px solid rgba(255,255,255,.06)" }}>
        <div className="lp-section">
          <Reveal>
            <div className="lp-section-label">4 portales integrados</div>
            <h2 className="lp-section-title">Un sistema.<br />Todos conectados.</h2>
            <p className="lp-section-sub">
              Cada actor tiene su propia interfaz optimizada. Sin menús innecesarios, sin funciones que no le corresponden.
            </p>
          </Reveal>
          <Reveal style={{ transitionDelay: ".15s" }}>
            <div className="lp-portals">
              <PortalCard
                emoji="🏪"
                badge="Vendedor / Admin"
                badgeColor="#FB923C"
                name="Panel de Vendedor"
                desc="Cola de pedidos en tiempo real, POS para venta inmediata, gestión de menú, facturación, reportes y configuración de la soda."
                bg="linear-gradient(135deg, rgba(251,146,60,.06), rgba(249,115,22,.03))"
                border="1px solid rgba(251,146,60,.15)"
              />
              <PortalCard
                emoji="👨‍👩‍👧‍👦"
                badge="Padres de familia"
                badgeColor="#8B5CF6"
                name="Portal de Padres"
                desc="Ver pedidos de sus hijos, recibir y pagar facturas semanales por SINPE, subir comprobantes, controlar el límite semanal de gasto."
                bg="linear-gradient(135deg, rgba(139,92,246,.06), rgba(124,58,237,.03))"
                border="1px solid rgba(139,92,246,.15)"
              />
              <PortalCard
                emoji="🎒"
                badge="Estudiantes"
                badgeColor="#4ADE80"
                name="Portal de Estudiantes"
                desc="Pedidos con código de estudiante y PIN. Para primaria: crédito a la cuenta del padre. Para colegio: saldo prepagado, efectivo o SINPE. Sin necesidad de celular ni correo."
                bg="linear-gradient(135deg, rgba(74,222,128,.06), rgba(22,163,74,.03))"
                border="1px solid rgba(74,222,128,.15)"
              />
              <PortalCard
                emoji="🖥️"
                badge="Punto de venta"
                badgeColor="#22D3EE"
                name="POS — Venta Inmediata"
                desc="Terminal de venta para el vendedor. Busca al estudiante por nombre o código, arma el pedido y registra el pago al instante."
                bg="linear-gradient(135deg, rgba(34,211,238,.06), rgba(6,182,212,.03))"
                border="1px solid rgba(34,211,238,.15)"
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section>
        <div className="lp-section">
          <Reveal>
            <div className="lp-section-label">Cómo funciona</div>
            <h2 className="lp-section-title">En producción<br />en menos de 1 hora</h2>
          </Reveal>
          <Reveal style={{ transitionDelay: ".1s" }}>
            <div className="lp-steps">
              {[
                { num: "01", title: "Solicitar acceso", desc: "Nos escribís por WhatsApp o correo. Creamos tu escuela en menos de 5 minutos." },
                { num: "02", title: "Cargar productos", desc: "El admin carga el menú con fotos y precios desde el Panel de Vendedor." },
                { num: "03", title: "Registrar padres", desc: "Los padres se registran solos en el Portal de Padres con el slug de la escuela." },
                { num: "04", title: "Empezar a operar", desc: "Los estudiantes piden, los vendedores despachan, los padres pagan. Así de simple." },
              ].map(s => (
                <div key={s.num} className="lp-step">
                  <div className="lp-step-num">{s.num}</div>
                  <div className="lp-step-title">{s.title}</div>
                  <div className="lp-step-desc">{s.desc}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── CHATBOT SECTION ── */}
      <section style={{ borderTop: "1px solid rgba(255,255,255,.06)" }}>
        <div className="lp-section" style={{ display: "flex", alignItems: "center", gap: 60, flexWrap: "wrap" }}>
          <Reveal style={{ flex: 1, minWidth: 280 }}>
            <div className="lp-section-label">Asistente con IA</div>
            <h2 className="lp-section-title">Soporte 24/7<br />sin costo extra</h2>
            <p style={{ fontSize: 17, color: "#64748B", lineHeight: 1.7, marginBottom: 28 }}>
              Cada portal tiene un asistente virtual integrado que responde preguntas al instante. Los padres preguntan cómo pagar, los estudiantes cómo entrar, los vendedores cómo configurar el menú — todo en lenguaje natural, sin manuales.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {[
                { emoji: "🟠", label: "Portal de Padres y Estudiantes", desc: "Responde sobre PIN, facturas, pedidos, pagos y saldo" },
                { emoji: "🟣", label: "Panel del Vendedor", desc: "Responde sobre cola, facturación, productos y configuración" },
                { emoji: "⚡", label: "Respuestas instantáneas", desc: "Usa IA de Anthropic — el mismo motor detrás de Claude" },
              ].map(item => (
                <div key={item.label} style={{ display: "flex", alignItems: "flex-start", gap: 14 }}>
                  <span style={{ fontSize: 20, flexShrink: 0, marginTop: 2 }}>{item.emoji}</span>
                  <div>
                    <div style={{ fontWeight: 700, color: "white", fontSize: 15 }}>{item.label}</div>
                    <div style={{ fontSize: 13, color: "#64748B" }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal style={{ flex: 1, minWidth: 280, transitionDelay: ".15s" }}>
            <div style={{ background: "#0D1520", border: "1px solid rgba(251,146,60,.2)", borderRadius: 24, padding: 28, maxWidth: 380 }}>
              {/* Mock chat UI */}
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid rgba(255,255,255,.06)" }}>
                <div style={{ width: 40, height: 40, borderRadius: 12, background: "white", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}><img src="/logo.png" alt="La Tiendita CR" style={{ width: 36, height: 36, objectFit: "contain" }} /></div>
                <div>
                  <div style={{ fontWeight: 700, color: "white", fontSize: 14 }}>Asistente Tiendita</div>
                  <div style={{ fontSize: 12, color: "#4ADE80" }}>● En línea</div>
                </div>
              </div>
              {[
                { role: "user", text: "¿Cómo entro al portal de estudiante?" },
                { role: "bot", text: "¡Hola! 👋 Necesitás tu código de estudiante (tipo EST00001) y tu PIN de 6 dígitos. Tu papá o mamá te los dieron cuando te registraron." },
                { role: "user", text: "¿Y si olvidé el PIN?" },
                { role: "bot", text: "Sin problema 😊 Tu papá o mamá pueden cambiarlo desde su portal en la sección Mis Hijos → Editar." },
              ].map((msg, i) => (
                <div key={i} style={{ display: "flex", justifyContent: msg.role === "user" ? "flex-end" : "flex-start", marginBottom: 10 }}>
                  <div style={{ maxWidth: "80%", padding: "10px 14px", borderRadius: msg.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px", background: msg.role === "user" ? "linear-gradient(135deg,#FB923C,#F97316)" : "#1E293B", border: msg.role === "bot" ? "1px solid rgba(255,255,255,.06)" : "none", fontSize: 13, color: "white", lineHeight: 1.5 }}>
                    {msg.text}
                  </div>
                </div>
              ))}
              <div style={{ marginTop: 16, padding: "10px 14px", background: "#1E293B", borderRadius: 12, border: "1px solid rgba(255,255,255,.08)", fontSize: 13, color: "#475569" }}>
                Escribí tu pregunta...
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── PRICING ── */}
      <section id="pricing" style={{ background: "rgba(255,255,255,.015)", borderTop: "1px solid rgba(255,255,255,.06)", borderBottom: "1px solid rgba(255,255,255,.06)" }}>
        <div className="lp-section">
          <Reveal>
            <div className="lp-section-label">Precios</div>
            <h2 className="lp-section-title">Transparente.<br />Sin sorpresas.</h2>
            <p className="lp-section-sub">
              Todos los planes incluyen acceso completo al sistema. Sin costo de instalación, sin contrato mínimo.
            </p>
          </Reveal>
          <Reveal style={{ transitionDelay: ".15s" }}>
            <div className="lp-pricing">
              <PlanCard
                name="Free"
                desc="Para empezar sin riesgo. Ideal para sodas pequeñas o que quieren probar el sistema."
                price="₡0"
                period="/mes"
                limit="Hasta 50 estudiantes"
                ctaStyle="outline"
                cta="Empezar gratis"
                onCta={openWhatsApp}
                features={[
                  { ok: true,  label: "Cola de pedidos ilimitada" },
                  { ok: true,  label: "Hasta 2 vendedores" },
                  { ok: true,  label: "1 localidad" },
                  { ok: true,  label: "Portal de padres y estudiantes" },
                  { ok: false, label: "Exportar reportes PDF" },
                  { ok: false, label: "Menú semanal" },
                  { ok: false, label: "Pedidos programados" },
                ]}
              />
              <PlanCard
                name="Basic"
                desc="La opción más popular. Cubre todo lo que una soda escolar necesita para operar profesionalmente."
                price="₡15.000"
                period="/mes"
                limit="Hasta 300 estudiantes"
                ctaStyle="orange"
                cta="Solicitar demo"
                featured
                badge="⭐ Más popular"
                onCta={openWhatsApp}
                features={[
                  { ok: true, label: "Cola de pedidos ilimitada" },
                  { ok: true, label: "Hasta 5 vendedores" },
                  { ok: true, label: "Hasta 3 localidades" },
                  { ok: true, label: "Exportar reportes PDF (diario, semanal, mensual)" },
                  { ok: true, label: "Menú semanal interactivo" },
                  { ok: true, label: "Pedidos programados por estudiantes" },
                  { ok: true, label: "Notificaciones por correo a padres" },
                ]}
              />
              <PlanCard
                name="Premium"
                desc="Para instituciones grandes o con operaciones complejas. Sin límites en nada."
                price="₡35.000"
                period="/mes"
                limit="Estudiantes ilimitados"
                ctaStyle="outline"
                cta="Consultar"
                onCta={openWhatsApp}
                features={[
                  { ok: true, label: "Todo lo del plan Basic" },
                  { ok: true, label: "Vendedores ilimitados" },
                  { ok: true, label: "Localidades ilimitadas" },
                  { ok: true, label: "Soporte prioritario (WhatsApp directo)" },
                  { ok: true, label: "Onboarding asistido por videollamada" },
                  { ok: true, label: "Personalización de logo y colores" },
                  { ok: true, label: "Próximas funciones antes que nadie" },
                ]}
              />
            </div>
          </Reveal>
          <Reveal style={{ transitionDelay: ".2s" }}>
            <p style={{ textAlign: "center", marginTop: 36, fontSize: 14, color: "#475569" }}>
              Precios en colones costarricenses. Pago mensual por SINPE. Sin contratos de permanencia.
            </p>
          </Reveal>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section style={{ borderTop: "1px solid rgba(255,255,255,.06)" }}>
        <div className="lp-section">
          <Reveal>
            <div className="lp-section-label">Preguntas frecuentes</div>
            <h2 className="lp-section-title">Todo lo que querés saber</h2>
          </Reveal>
          <Reveal style={{ transitionDelay: ".1s" }}>
            <FaqSection />
          </Reveal>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section id="contact" className="lp-cta-section">
        <Reveal>
          <h2 className="lp-cta-title">¿Listo para ordenar<br />la soda de tu escuela?</h2>
          <p className="lp-cta-sub">
            El primer mes es gratis. Sin tarjeta de crédito. Sin instalaciones.<br />
            Solo escribinos y lo configuramos juntos.
          </p>
          <button className="lp-wa-btn" onClick={openWhatsApp}>
            <span style={{ fontSize: 22 }}>💚</span>
            Escribinos por WhatsApp
          </button>
          <p style={{ marginTop: 20, fontSize: 13, color: "#334155" }}>
            También podés escribirnos a <span style={{ color: "#64748B" }}>marcoscastrocr@gmail.com</span>
          </p>
        </Reveal>
      </section>

      {/* ── FOOTER ── */}
      <footer className="lp-footer">
        <div className="lp-footer-logo"><img src="/logo.png" alt="La Tiendita CR" style={{ height: 32, width: "auto", objectFit: "contain" }} /></div>
        <div className="lp-footer-copy">© {new Date().getFullYear()} · tienditacr.app · Costa Rica</div>
      </footer>
    </div>
  );
}
